import { useIntl } from 'react-intl';

export default function SentryErrorFallback() {
  const intl = useIntl();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
      <div className="max-w-md rounded-lg bg-white p-8 text-center shadow-md">
        <h1 className="mb-3 text-xl font-semibold text-gray-900">
          {intl.formatMessage({ id: 'alerts.sentryTitle' })}
        </h1>
        <p className="text-gray-600">
          {intl.formatMessage({ id: 'alerts.sentryBody' })}
        </p>
        <button
          type="button"
          className="mt-6 rounded bg-blue-900 px-4 py-2 text-white hover:bg-blue-800"
          onClick={() => window.location.reload()}
        >
          {intl.formatMessage({ id: 'alerts.sentryRefresh' })}
        </button>
      </div>
    </div>
  );
}
